import { InfoAlert } from "features/practitioner/utils";
import { useAppContext } from "providers/AppProvider";
import React from "react";
import { Button, Card, Col, Row } from "react-bootstrap";
import { Download } from "react-bootstrap-icons";
import BranchExcelUpload from "./BranchExcelUpload";
import { useSelector } from "react-redux";

const BranchUploadStep = ({ control, watch, setValue, errors }) => {
  const handleDownloadTemplate = () => {
    const link = document.createElement("a");
    link.href = "/BranchesListTemplate.xlsx";
    link.setAttribute("download", "BranchesListTemplate.xlsx");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
  const {
    config: { theme },
  } = useAppContext();

  const { allPermissionType } = useSelector((state) => state.role);
  const branchSetting = allPermissionType?.[0]?.rolemngmt_name?.find(
    (item) => item?.rolemngmttyp_name === "Branch"
  );
  return (
    <Row>
      <Col xs={12}>
        <InfoAlert>
          Download the template, fill it with your branch data, then upload it
          here. The system will validate your data before import.
        </InfoAlert>
      </Col>
      <Row className="d-flex align-items-stretch">
        <Col xs={12} md={6}>
          <Card className="">
            <Card.Body className="text-center d-flex flex-column">
              <div className="mb-4">
                <div
                  className="rounded-circle bg-primary bg-opacity-10 text-primary d-flex align-items-center mb-3 justify-content-center mx-auto"
                  style={{ width: 80, height: 80 }}
                >
                  <Download size={28} />
                </div>
                <h5 className="fw-bold mb-2">Excel Template</h5>
                <p className="text-muted mb-4">
                  Download our preformatted Excel template to ensure your data
                  is structured correctly
                </p>
              </div>
              <div className="mt-auto">
                <Button
                  variant="primary"
                  className="d-flex align-items-center justify-content-center mx-auto"
                  onClick={handleDownloadTemplate}
                >
                  Download Template
                </Button>
              </div>
            </Card.Body>
          </Card>
        </Col>
        <Col xs={12} md={6} className="mb-4">
          {branchSetting?.import ? (
            <BranchExcelUpload
              watch={watch}
              theme={theme}
              control={control}
              errors={errors}
              setValue={setValue}
            />
          ) : (
            <div className="text-center py-6">
              You don't permission to import Branch
            </div>
          )}
        </Col>
      </Row>
    </Row>
  );
};

export default BranchUploadStep;
